import React from 'react'
import { Button, ButtonProps } from '@mui/material'

const MuiButton: React.FC<ButtonProps> = (props: ButtonProps) => {
  return <Button variant='contained' color='primary' {...props} />
}

export default MuiButton
